module.exports = __webpack_public_path__ + "assets/images/shop7.b9a5aaf8.png";